var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDistanceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1278_15553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58334 4.16699H9.94534C12.4847 4.16699 13.7544 4.16699 14.2364 4.62307C14.653 5.0173 14.8376 5.59806 14.7251 6.1605C14.595 6.81117 13.5584 7.54437 11.4852 9.01077L8.0981 11.4065C6.02493 12.8729 4.98833 13.6061 4.8582 14.2568C4.74572 14.8193 4.93035 15.4 5.34697 15.7943C5.82895 16.2503 7.09864 16.2503 9.63801 16.2503H10.4167M6.66667 4.16699C6.66667 5.5477 5.54738 6.66699 4.16667 6.66699C2.78596 6.66699 1.66667 5.5477 1.66667 4.16699C1.66667 2.78628 2.78596 1.66699 4.16667 1.66699C5.54738 1.66699 6.66667 2.78628 6.66667 4.16699ZM18.3333 15.8337C18.3333 17.2144 17.2141 18.3337 15.8333 18.3337C14.4526 18.3337 13.3333 17.2144 13.3333 15.8337C13.3333 14.4529 14.4526 13.3337 15.8333 13.3337C17.2141 13.3337 18.3333 14.4529 18.3333 15.8337Z",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1278_15553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceIcon);
export default __webpack_public_path__ + "static/media/distanceIcon.696cc6903259df743602bc9c41f55c52.svg";
export { ForwardRef as ReactComponent };